import api from './api';

const productService = {
    /**
     * Ürünleri listeler ve arama yapar
     * @param {string} searchText - Aranacak metin
     * @param {string} model3bCheck - 3B model filtresi ('0' veya '1')
     * @returns {Promise<Array>} Ürün listesi
     */
    getProducts: async (searchText, model3bCheck) => {
        try {
            const response = await api.get(`productlist/${searchText}/${model3bCheck}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Ürün gruplarını getirir
     * @param {string} groupCode - Grup kodu
     * @returns {Promise<Array>} Grup listesi
     */
    getProductGroups: async (groupCode) => {
        try {
            const response = await api.get(`ProductGroup/${groupCode}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Dosya indirme işlemi (PDF veya STEP)
     * @param {string} fileName - İndirilecek dosya adı
     * @param {string|number} userId - Kullanıcı ID veya Activation Key
     * @param {number} productId - Ürün ID
     * @param {string} fileType - 'pdf' veya 'step'
     * @returns {Promise<Blob>} Dosya verisi (Blob)
     */
    downloadFile: async (fileName, userId, productId, fileType) => {
        const acceptHeader = fileType === 'pdf' ? 'application/pdf' : 'application/step';
        
        try {
            const response = await api.post(`DownloadFile/${fileName}`, 
                {
                    DosyaAdi: fileName,
                    UserId: userId,
                    UrunId: productId
                },
                {
                    responseType: 'blob',
                    headers: {
                        'Accept': acceptHeader
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Tek bir ürünü ID ile getirir
     * @param {number} id - Ürün ID'si
     * @returns {Promise<Object>} Ürün nesnesi
     */
    getProductById: async (id) => {
        try {
            const response = await api.get(`Urun/${id}`);
            if (response.data && response.data.length > 0) {
                return response.data[0];
            }
            return null;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Katalog kodunu çözümler
     * @param {string} code - Çözümlenecek katalog kodu
     * @returns {Promise<Object>} Çözümlenmiş ürün bilgisi
     */
    parseCode: async (code) => {
        try {
            const response = await api.get('Urun/ParseCode', {
                params: { code }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * KOD AÇIKLAMASI butonu tıklandığında (modal açıldığında) backend'e log isteği atar
     * @param {string} katalogKodu - Katalog kodu
     * @param {number} urunId - Ürün ID'si
     */
    logKodAciklamasi: async (katalogKodu, urunId) => {
        try {
            await api.get('Urun/LogKodAciklamasi', {
                params: {
                    katalogKodu,
                    urunId
                }
            });
        } catch (error) {
            console.error("Failed to log kod aciklamasi click", error);
        }
    }
};

export default productService;
